var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrid01Solid = function SvgGrid01Solid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    stroke: "#080808",
    strokeWidth: 1.2,
    d: "M2.6 11V3c0-.22.18-.4.4-.4h7c.22 0 .4.18.4.4v8a.4.4 0 0 1-.4.4H3a.4.4 0 0 1-.4-.4Zm11-5V3c0-.22.18-.4.4-.4h7c.22 0 .4.18.4.4v3a.4.4 0 0 1-.4.4h-7a.4.4 0 0 1-.4-.4Zm0 4c0-.22.18-.4.4-.4h7c.22 0 .4.18.4.4v4a.4.4 0 0 1-.4.4h-7a.4.4 0 0 1-.4-.4v-4Zm0 11v-3c0-.22.18-.4.4-.4h7c.22 0 .4.18.4.4v3a.4.4 0 0 1-.4.4h-7a.4.4 0 0 1-.4-.4Zm-3.2-6v6a.4.4 0 0 1-.4.4H3a.4.4 0 0 1-.4-.4v-6c0-.22.18-.4.4-.4h7c.22 0 .4.18.4.4Z"
  })));
};
export default SvgGrid01Solid;